// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactPromptSection_section__FxGRl {
  position: relative;
  margin-top: calc(var(--space-xxl) * 2);
  padding-bottom: var(--space-xxl);
}

.ContactPromptSection_layout__k53SG {
  display: grid;
  grid-template-columns: minmax(0, 1.28fr) minmax(16rem, 22rem);
  gap: var(--space-xl);
  align-items: center;
  padding-top: var(--space-lg);
}

.ContactPromptSection_copy__AVDfQ {
  position: relative;
}

.ContactPromptSection_label__eP8J3 {
  color: var(--color-text-subtle);
  font-size: var(--font-size-small);
  margin-bottom: var(--space-sm);
}

.ContactPromptSection_title__KJ1eQ {
  font-size: var(--font-size-xlarge);
  font-weight: var(--font-weight-bold);
  line-height: 1.05;
  margin-bottom: var(--space-sm);
}

.ContactPromptSection_text__lmKTR {
  max-width: 42rem;
  font-size: var(--font-size-base);
  line-height: var(--line-height-base);
  color: var(--color-text);
}

.ContactPromptSection_form__h3hlm {
  margin-top: var(--space-lg);
}

.ContactPromptSection_formRow__MxWhx {
  display: flex;
  gap: var(--space-md);
}

.ContactPromptSection_formGroup__dZ-e3 {
  flex: 1 1;
  margin-bottom: var(--space-md);
}

.ContactPromptSection_formGroup__dZ-e3 label {
  display: block;
  margin-bottom: var(--space-xs);
  color: rgba(255, 255, 255, 0.78);
  font-size: var(--font-size-small);
}

.ContactPromptSection_formGroup__dZ-e3 input,
.ContactPromptSection_formGroup__dZ-e3 textarea {
  width: 100%;
  padding: calc(var(--space-xs) * 0.95) var(--space-sm);
  font-size: var(--font-size-base);
  color: var(--color-text);
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0.85rem;
  outline: none;
  transition: border-color 0.25s ease, background-color 0.25s ease,
    box-shadow 0.25s ease;
}

.ContactPromptSection_formGroup__dZ-e3 input::placeholder,
.ContactPromptSection_formGroup__dZ-e3 textarea::placeholder {
  color: rgba(255, 255, 255, 0.32);
}

.ContactPromptSection_formGroup__dZ-e3 input:focus,
.ContactPromptSection_formGroup__dZ-e3 textarea:focus {
  border-color: rgba(77, 163, 255, 0.75);
  background: rgba(255, 255, 255, 0.06);
  box-shadow: 0 0 0 3px rgba(77, 163, 255, 0.12);
}

.ContactPromptSection_formGroup__dZ-e3 textarea {
  min-height: 8rem;
  resize: vertical;
}

.ContactPromptSection_checkboxRow__\\+6XWl {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin: var(--space-sm) 0 var(--space-md);
  color: rgba(255, 255, 255, 0.78);
  font-size: var(--font-size-small);
  cursor: pointer;
}

.ContactPromptSection_checkboxRow__\\+6XWl input {
  appearance: none;
  -webkit-appearance: none;
  flex: 0 0 1.05rem;
  width: 1.05rem;
  height: 1.05rem;
  margin: 0.14rem 0 0;
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 0.35rem;
  background: rgba(255, 255, 255, 0.04);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.3s ease, background-color 0.3s ease,
    box-shadow 0.3s ease;
}

.ContactPromptSection_checkboxRow__\\+6XWl input:focus-visible {
  box-shadow: 0 0 0 3px rgba(77, 163, 255, 0.15);
}

.ContactPromptSection_checkboxRow__\\+6XWl input:checked {
  background: #4da3ff;
  border-color: #4da3ff;
}

.ContactPromptSection_checkboxRow__\\+6XWl input:checked::after {
  content: "";
  width: 0.28rem;
  height: 0.55rem;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin-top: -0.08rem;
}

.ContactPromptSection_checkboxRow__\\+6XWl span {
  line-height: 1.4;
}

.ContactPromptSection_profile__9jzfL {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: center;
}

.ContactPromptSection_image__VGCq3 {
  width: min(100%, 18rem);
  height: auto;
  border-radius: 1rem;
  align-self: center;
}

.ContactPromptSection_button__Dq8sj {
  margin-top: var(--space-xs);
  background-color: var(--color-text);
  color: var(--color-background);
  border: none;
  border-radius: 25px;
  padding: var(--space-xs) var(--space-sm);
  font-size: var(--font-size-small);
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.ContactPromptSection_button__Dq8sj:hover {
  background-color: var(--color-text-subtle);
  color: var(--color-background);
}

.ContactPromptSection_button__Dq8sj:disabled {
  opacity: 0.7;
  cursor: wait;
}

.ContactPromptSection_statusMessage__NhaXk {
  margin-top: var(--space-sm);
  font-size: var(--font-size-small);
  color: rgba(255, 255, 255, 0.72);
}

.ContactPromptSection_signature__ojzp5 {
  margin-top: var(--space-md);
  text-align: center;
}

.ContactPromptSection_name__cUK12 {
  font-size: var(--font-size-medium);
  margin: 0;
  color: var(--color-text);
}

.ContactPromptSection_role__4SI8y {
  font-size: var(--font-size-small);
  margin: 0;
  color: var(--color-text-subtle);
}

@media (max-width: 768px) {
  .ContactPromptSection_layout__k53SG {
    grid-template-columns: 1fr;
    align-items: start;
  }

  .ContactPromptSection_text__lmKTR {
    font-size: var(--font-size-medium);
  }

  .ContactPromptSection_formRow__MxWhx {
    flex-direction: column;
    gap: 0;
  }

  .ContactPromptSection_profile__9jzfL {
    order: 2;
    align-items: center;
  }

  .ContactPromptSection_signature__ojzp5 {
    order: 3;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ContactPromptSection.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,qDAAqD;EACrD,gCAAgC;EAChC,wBAAwB;EACxB,sCAAsC;EACtC,2CAA2C;EAC3C,sBAAsB;EACtB,aAAa;EACb;yBACuB;AACzB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,sCAAsC;EACtC,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,yCAAyC;EACzC,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,sBAAsB;EACtB,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,iCAAiC;EACjC,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;AACF","sourcesContent":[".section {\n  position: relative;\n  margin-top: calc(var(--space-xxl) * 2);\n  padding-bottom: var(--space-xxl);\n}\n\n.layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1.28fr) minmax(16rem, 22rem);\n  gap: var(--space-xl);\n  align-items: center;\n  padding-top: var(--space-lg);\n}\n\n.copy {\n  position: relative;\n}\n\n.label {\n  color: var(--color-text-subtle);\n  font-size: var(--font-size-small);\n  margin-bottom: var(--space-sm);\n}\n\n.title {\n  font-size: var(--font-size-xlarge);\n  font-weight: var(--font-weight-bold);\n  line-height: 1.05;\n  margin-bottom: var(--space-sm);\n}\n\n.text {\n  max-width: 42rem;\n  font-size: var(--font-size-base);\n  line-height: var(--line-height-base);\n  color: var(--color-text);\n}\n\n.form {\n  margin-top: var(--space-lg);\n}\n\n.formRow {\n  display: flex;\n  gap: var(--space-md);\n}\n\n.formGroup {\n  flex: 1;\n  margin-bottom: var(--space-md);\n}\n\n.formGroup label {\n  display: block;\n  margin-bottom: var(--space-xs);\n  color: rgba(255, 255, 255, 0.78);\n  font-size: var(--font-size-small);\n}\n\n.formGroup input,\n.formGroup textarea {\n  width: 100%;\n  padding: calc(var(--space-xs) * 0.95) var(--space-sm);\n  font-size: var(--font-size-base);\n  color: var(--color-text);\n  background: rgba(255, 255, 255, 0.045);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 0.85rem;\n  outline: none;\n  transition: border-color 0.25s ease, background-color 0.25s ease,\n    box-shadow 0.25s ease;\n}\n\n.formGroup input::placeholder,\n.formGroup textarea::placeholder {\n  color: rgba(255, 255, 255, 0.32);\n}\n\n.formGroup input:focus,\n.formGroup textarea:focus {\n  border-color: rgba(77, 163, 255, 0.75);\n  background: rgba(255, 255, 255, 0.06);\n  box-shadow: 0 0 0 3px rgba(77, 163, 255, 0.12);\n}\n\n.formGroup textarea {\n  min-height: 8rem;\n  resize: vertical;\n}\n\n.checkboxRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin: var(--space-sm) 0 var(--space-md);\n  color: rgba(255, 255, 255, 0.78);\n  font-size: var(--font-size-small);\n  cursor: pointer;\n}\n\n.checkboxRow input {\n  appearance: none;\n  -webkit-appearance: none;\n  flex: 0 0 1.05rem;\n  width: 1.05rem;\n  height: 1.05rem;\n  margin: 0.14rem 0 0;\n  border: 1px solid rgba(255, 255, 255, 0.32);\n  border-radius: 0.35rem;\n  background: rgba(255, 255, 255, 0.04);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: border-color 0.3s ease, background-color 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.checkboxRow input:focus-visible {\n  box-shadow: 0 0 0 3px rgba(77, 163, 255, 0.15);\n}\n\n.checkboxRow input:checked {\n  background: #4da3ff;\n  border-color: #4da3ff;\n}\n\n.checkboxRow input:checked::after {\n  content: \"\";\n  width: 0.28rem;\n  height: 0.55rem;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  margin-top: -0.08rem;\n}\n\n.checkboxRow span {\n  line-height: 1.4;\n}\n\n.profile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n}\n\n.image {\n  width: min(100%, 18rem);\n  height: auto;\n  border-radius: 1rem;\n  align-self: center;\n}\n\n.button {\n  margin-top: var(--space-xs);\n  background-color: var(--color-text);\n  color: var(--color-background);\n  border: none;\n  border-radius: 25px;\n  padding: var(--space-xs) var(--space-sm);\n  font-size: var(--font-size-small);\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.button:hover {\n  background-color: var(--color-text-subtle);\n  color: var(--color-background);\n}\n\n.button:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n.statusMessage {\n  margin-top: var(--space-sm);\n  font-size: var(--font-size-small);\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.signature {\n  margin-top: var(--space-md);\n  text-align: center;\n}\n\n.name {\n  font-size: var(--font-size-medium);\n  margin: 0;\n  color: var(--color-text);\n}\n\n.role {\n  font-size: var(--font-size-small);\n  margin: 0;\n  color: var(--color-text-subtle);\n}\n\n@media (max-width: 768px) {\n  .layout {\n    grid-template-columns: 1fr;\n    align-items: start;\n  }\n\n  .text {\n    font-size: var(--font-size-medium);\n  }\n\n  .formRow {\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .profile {\n    order: 2;\n    align-items: center;\n  }\n\n  .signature {\n    order: 3;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `ContactPromptSection_section__FxGRl`,
	"layout": `ContactPromptSection_layout__k53SG`,
	"copy": `ContactPromptSection_copy__AVDfQ`,
	"label": `ContactPromptSection_label__eP8J3`,
	"title": `ContactPromptSection_title__KJ1eQ`,
	"text": `ContactPromptSection_text__lmKTR`,
	"form": `ContactPromptSection_form__h3hlm`,
	"formRow": `ContactPromptSection_formRow__MxWhx`,
	"formGroup": `ContactPromptSection_formGroup__dZ-e3`,
	"checkboxRow": `ContactPromptSection_checkboxRow__+6XWl`,
	"profile": `ContactPromptSection_profile__9jzfL`,
	"image": `ContactPromptSection_image__VGCq3`,
	"button": `ContactPromptSection_button__Dq8sj`,
	"statusMessage": `ContactPromptSection_statusMessage__NhaXk`,
	"signature": `ContactPromptSection_signature__ojzp5`,
	"name": `ContactPromptSection_name__cUK12`,
	"role": `ContactPromptSection_role__4SI8y`
};
export default ___CSS_LOADER_EXPORT___;
